<template>
  <div>
    <Affix>
      <div class="navbar">
        <div class="navbar-inner">
          <span>
            <img class="logo" v-if="projectConfig.app_logo" :src="projectConfig.project_name==='xining'?logo:projectConfig.app_logo" alt="">
          </span>

          <!-- {{ projectConfig }} -->
          <div class="link-group">
            <a v-if="projectConfig.app_home_url" :href="projectConfig.app_home_url" class="link" :style="{'border-bottom-color':colors[0]}">
              <p>回到首页</p>
            </a>
            <div
              class="link"
              v-for="(item, index) in navData"
              :key="index"
              @click="toPage(item)"
              :style="{
                'border-bottom-color': colors[(index+1) % 11]
              }"
            >
              <p>{{ item.name }}</p>
            </div>
            <!-- <div
              class="link"
              :style="{
                'border-bottom-color': colors[3 % 11]
              }">
              <span @click="toPage({to: '/myOrder'})">我的订单</span>
            </div> -->
          </div>
        </div>
      </div>

      <div class="blue-bar">
        <div class="blue-bar-inner">
          <p class="title">{{ projectConfig.app_title }}</p>

          <div class="account">

            <template v-if="username">
              <span @click="toPage({to: '/myOrder'})">您好，{{ username }}</span> &emsp;
              <span @click="logout">退出账号</span>

              <el-badge :value="cartNum" class="item">
                <el-button
                  @click="$router.push('/cart')"
                  type="primary"
                  icon="el-icon-shopping-cart-2"
                  style="margin-left:20px">购物车</el-button>
              </el-badge>
            </template>

            <span @click="toPage({to: '/login'})" v-else>请登录</span>
          </div>
        </div>
      </div>
    </Affix>
  </div>
</template>

<script>
import { getLocal, clearLocal } from '@/util'
import { logout } from '@/api'
import { mapState } from 'vuex'
import Affix from './Affix'

export default {
  name: 'Navbar',
  components: {
    Affix
  },
  data () {
    return {
      colors: ['#D34C8D', '#F3A940', '#E0DB73', '#83C395', '#6D8BBB', '#4B76B1', '#8D65A0', '#AF629B'],
      logo: require('../assets/logo.png'),
      homeLink: window.config && window.config.homeLink

    }
  },
  computed: {
    ...mapState(['username', 'showMember']),
    projectConfig () {
      return this.$store.state.projectConfig
    },
    cartNum () {
      return this.$store.getters.cartNum
    },
    navData () {
      const nav = [
        {
          name: '门票预订',
          to: '/ticket'
        },
        {
          name: '会员预订',
          to: '/member'
        },
        {
          name: '我的订单',
          to: '/myOrder'
        }
      ]

      if (!this.showMember) {
        nav.splice(1, 1)
      }

      return nav
    }
  },
  mounted () {
    const username = getLocal('tmly_username')
    this.$store.commit('setUsername', username)
  },
  methods: {
    toPage (item) {
      if (item.to) {
        this.$router.push(item.to)
      } else if (item.link) {
        window.open(item.link, '_blank')
      }
    },
    logout () {
      logout().then(res => {
        clearLocal('tmly_username')
        clearLocal('pc_token')
        this.$store.commit('setUsername', null)
        this.$router.push('/login')
      })
    }
  }
}
</script>
<style lang="less">
.navbar {
  height: 70px;  background-color: #fff; width: 100%;
  .navbar-inner {
    display: flex; width: 900px; height: 70px;  margin: 0 auto; font-weight: bold;  color: @deep; justify-content: space-between; align-items: center;
    a{
      color: @deep; text-decoration: none;
    }
  }
  .logo {
    height: 60px;
  }
  .link-group {
    display: flex; align-items: center;
  }
  .link {
    position: relative; height: 40px;  padding: 0 15px; line-height: 40px;  cursor: pointer;  border-top: 5px solid transparent;  border-bottom: 5px solid transparent;
  }
}
.blue-bar {
  width: 100%;  height: @blueBarHeight;  background-color: @blue;  @blueBarHeight: 50px;
  .blue-bar-inner {
    display: flex; width: 900px; height: @blueBarHeight;  margin: 0 auto; color: #fff; text-align: left; justify-content: space-between; align-items: center;
    .title {
      font-size: 18px;
    }
  }
}

</style>
